import { render } from "./CentrapayQRCode.vue?vue&type=template&id=c0b481d6&scoped=true&lang=en"
import script from "./CentrapayQRCode.vue?vue&type=script&lang=js"
export * from "./CentrapayQRCode.vue?vue&type=script&lang=js"

import "./CentrapayQRCode.vue?vue&type=style&index=0&id=c0b481d6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c0b481d6"

export default script